<nz-modal
  [(nzVisible)]="isVisible"
  nzTitle="{{type === 'add' ? 'Add New Payment' : 'Edit Payment'}}"
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()"
  [nzWidth]="600"
>
  <ng-container *nzModalContent>
    <section id="paymentForm">
      <nz-card *ngIf="!popupLoading">
        <div>
          <form nz-form [formGroup]="paymentForm" [nzLayout]="'vertical'">
            <div class="grid md:grid-cols-1 gap-3">
              <div class="grid gap-3">
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="type" nzRequired>Type</nz-form-label>
                  <nz-form-control [nzErrorTip]="category">
                    <nz-select formControlName="type" nzAllowClear nzPlaceHolder="Select Type">
                      <nz-option nzValue="CARD" nzLabel="Card"></nz-option>
                      <nz-option nzValue="CASH" nzLabel="Cash"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #category>
                    <span *ngIf="paymentForm.get('type').hasError('required')">Please select type.</span>
                  </ng-template>
                </nz-form-item>
              </div>
            </div>

            <!--            <div class="grid md:grid-cols-1 gap-3">-->
            <!--              <div class="grid sm:grid-cols-1 gap-3">-->
            <!--                <nz-form-item class="grid grid-flow-row content-start">-->
            <!--                  <nz-form-label nzFor="item" nzRequired>Item</nz-form-label>-->
            <!--                  <nz-form-control [nzErrorTip]="nameSupplier">-->
            <!--                    <input nz-input type="text" [maxLength]="70"-->
            <!--                           formControlName="item" placeHolder="Enter Item"/>-->
            <!--                  </nz-form-control>-->
            <!--                  <ng-template #nameSupplier>-->
            <!--                <span-->
            <!--                  *ngIf="paymentForm.get('item').hasError('required')">Please enter item</span>-->
            <!--                  </ng-template>-->
            <!--                </nz-form-item>-->
            <!--              </div>-->
            <!--            </div>-->

            <div>
              <div class="grid xl:grid-cols-1 gap-2">
                <div>
                  <div class="my-1">
                    <nz-form-label class="col-span-2" nzRequired>Items
                    </nz-form-label>
                  </div>
                  <div formArrayName="items" *ngFor="let item of items.controls; let costIndex = index">
                    <div class="grid sm:grid-cols-5 gap-2">
                      <nz-form-label class="col-span-2" *ngIf="costIndex === 0" nzFor="chargeType">Item
                      </nz-form-label>
                      <nz-form-label class="col-span-2" *ngIf="costIndex === 0" nzFor="chargeCost">Amount
                      </nz-form-label>
                    </div>
                    <div class="grid sm:grid-cols-5 gap-2 my-1">
                      <nz-form-item [formGroupName]="costIndex"
                                    class="col-span-2 grid grid-flow-row content-start mb-0">
                        <!--                    <nz-form-label *ngIf="costIndex === 0" nzFor="chargeType" nzRequired>Charge Type</nz-form-label>-->
                        <nz-form-control [nzErrorTip]="chargeTypeError">
                          <nz-select id="chargeTypeId" class="w-full" formControlName="chargeType"
                                     nzPlaceHolder="Select Preference"
                                     nzShowSearch nzAllowClear [nzDropdownRender]="renderTemplate"
                          >
                            <nz-option *ngFor="let item of chargesOptions" [nzLabel]="item.chargeType"
                                       [nzValue]="item"></nz-option>
                          </nz-select>
                          <ng-template #renderTemplate>
                            <nz-divider></nz-divider>
                            <div class="flex flex-col justify-center mx-3">
                              <input type="text" nz-input #inputElement/>
                              <a class="text-center m-1" (click)="addItem(inputElement)">
                                <span nz-icon nzType="plus"></span>
                                Add item
                              </a>
                            </div>
                          </ng-template>
                        </nz-form-control>
                        <ng-template #chargeTypeError>
                      <span
                        *ngIf="formErrors?.bookingCostInformation?.chargeType?.required">Please select charge type. </span>
                        </ng-template>
                      </nz-form-item>
                      <nz-form-item [formGroupName]="costIndex"
                                    class="col-span-2 w-full grid grid-flow-row content-start mb-0">
                        <!--                    <nz-form-label *ngIf="costIndex === 0" nzFor="chargeCost" nzRequired>Value</nz-form-label>-->
                        <nz-form-control [nzErrorTip]="chargeCostError">
                          <!--&lt;!&ndash;                      <nz-input-group [nzAddOnAfter]="deleteButton">&ndash;&gt;-->
                          <!--                        <nz-input-number class="w-full" formControlName="chargeCost"-->
                          <!--                                         nzPlaceHolder="Enter Number"></nz-input-number>-->
                          <!--                      </nz-input-group>-->
                          <nz-input-number-group [nzAddOnAfter]="extraAddOnAfterTemplate">
                            <nz-input-number formControlName="amount" [nzPlaceHolder]="'Enter Number'" [nzStep]="1"
                                             [nzMin]="0"></nz-input-number>
                          </nz-input-number-group>
                          <ng-template #extraAddOnAfterTemplate>
                            <nz-select formControlName="currency"
                                       [nzPlaceHolder]="'...'"
                                       style="width: 75px">
                              <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                                         [nzLabel]="op.currencyCode"></nz-option>
                            </nz-select>
                          </ng-template>
                          <!--                    <input nz-input type="text" formControlName="chargeCost" placeholder="Enter Number"/>-->
                        </nz-form-control>
                        <ng-template #chargeCostError>
                          <span
                            *ngIf="formErrors?.bookingCostInformation?.chargeCost?.required">Please enter value. </span>
                        </ng-template>
                        <ng-template>
                        </ng-template>
                      </nz-form-item>
                      <button class="col-span-1" nz-button nzType="text" nzDanger
                              (click)="deleteItem(costIndex)"><span nz-icon
                                                                    nzType="delete"
                                                                    nzTheme="outline"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <button class="outline-button" nz-button nzType="default" nz-popconfirm
                        (click)="addPaymentItem()">
                  <span nz-icon nzType="plus" nzTheme="outline"></span></button>
              </div>
              <!--              <div class="flex">-->
              <!--                <p>Total - </p>-->
              <!--                <p class="ml-3">{{totalExtraChargesInLKR}} LKR</p>-->
              <!--              </div>-->
              <nz-divider></nz-divider>
            </div>

            <!--            <div class="grid sm:grid-cols-1 mb-3 w-full">-->
            <!--              <nz-form-item class="grid grid-flow-row content-start mb-0">-->
            <!--                <nz-form-label nzFor="totalAmount" nzRequired>Amount</nz-form-label>-->
            <!--                <nz-form-control [nzErrorTip]="allocatedDriverVehicleError">-->
            <!--                  <nz-input-number-group>-->
            <!--                    <nz-input-number formControlName="totalAmount" [nzPlaceHolder]="'Enter Amount'" [nzStep]="1"-->
            <!--                                     [nzMin]="0"></nz-input-number>-->
            <!--                  </nz-input-number-group>-->
            <!--&lt;!&ndash;                  <ng-template #addOnAfterTemplate>&ndash;&gt;-->
            <!--&lt;!&ndash;                    <nz-select formControlName="currency"&ndash;&gt;-->
            <!--&lt;!&ndash;                               [nzPlaceHolder]="'...'" style="width: 75px">&ndash;&gt;-->
            <!--&lt;!&ndash;                      <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"&ndash;&gt;-->
            <!--&lt;!&ndash;                                 [nzLabel]="op.currencyCode"></nz-option>&ndash;&gt;-->
            <!--&lt;!&ndash;                    </nz-select>&ndash;&gt;-->
            <!--&lt;!&ndash;                  </ng-template>&ndash;&gt;-->
            <!--                </nz-form-control>-->
            <!--                <ng-template #allocatedDriverVehicleError>-->
            <!--                  <span-->
            <!--                    *ngIf="formErrors?.allocationDetails.oursourcedRate?.required">Please enter amount </span>-->
            <!--                </ng-template>-->
            <!--              </nz-form-item>-->
            <!--            </div>-->
            <div class="grid sm:grid-cols-1 mb-6 w-full">
              <div class="flex justify-between gap-3">
                <div class="font-bold">Total Amount in LKR</div>
                <div class="font-bold">{{paymentForm.get('totalAmount').value| number:'1.2-2'}}</div>
              </div>
              <nz-divider></nz-divider>
            </div>

            <div class="grid md:grid-cols-1 gap-3">
              <div class="grid sm:grid-cols-1 gap-3">
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="description">Description</nz-form-label>
                  <nz-form-control [nzErrorTip]="nameSupplier">
                    <textarea nz-input formControlName="description" placeholder="Enter Description"
                              [nzAutosize]="{ minRows: 7, maxRows: 7 }"></textarea>
                  </nz-form-control>
                  <ng-template #nameSupplier>
                    <!--                <span-->
                    <!--                  *ngIf="paymentForm.get('descri').hasError('required')">Please Enter Agent Name</span>-->
                  </ng-template>
                </nz-form-item>
              </div>
            </div>
          </form>

          <div class="grid md:grid-cols-1 gap-3">
            <div class="grid sm:grid-cols-1 gap-3">
              <div>
                <p class="pb-[8px] font-normal">Attachments (Contracts)</p>

                <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
                  <div>
                    <nz-upload
                      [nzCustomRequest]="upload" [nzShowUploadList]="false" [nzMultiple]="false"
                      (cancel)="attachmentUploading = false">
                      <button nz-button>
                        <span nz-icon nzType="upload"></span>
                        Click to Upload
                      </button>
                    </nz-upload>
                  </div>
                  <div>
                    <p *ngIf="attachmentUploading" class="text-primary my-2">Uploading...</p>
                  </div>
                  <div class="mt-2 overflow-auto">
                    <div *ngFor="let file of attachments; let i = index"
                         class="flex justify-between items-center mx-3 gap-5">
                      <a target="_blank" href="{{file.url}}">{{file.name}}</a>
                      <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'"
                            [nzTwotoneColor]="'#ff0000'"
                            class="cursor-pointer" nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want to delete this attachment"
                            (nzOnConfirm)="confirmRemoveAttachment(i)"
                      ></span>
                    </div>
                  </div>
                </div>

                <!--              <nz-upload [nzCustomRequest]="upload" [nzShowUploadList]="false" [nzMultiple]="false"-->
                <!--                         class="flex justify-center items-center bg-slate-100 w-full h-32 xl:h-48">-->
                <!--                <button nz-button>-->
                <!--                  <span nz-icon nzType="upload"></span>-->
                <!--                  Click to Upload-->
                <!--                </button>-->
                <!--              </nz-upload>-->
                <!--              <div *ngFor="let file of paymentFiles;let i = index">-->
                <!--                <a class="" target="_blank" href="{{file.url}}">{{file.name}} <span nz-icon nzType="close" nz-popconfirm-->
                <!--                                                                                    nzPopconfirmTitle="Are you sure you want to delete the attachment"-->
                <!--                                                                                    nzPopconfirmPlacement="bottom"-->
                <!--                                                                                    (nzOnConfirm)="confirmRemoveAttachment(i)"-->
                <!--                                                                                    (nzOnCancel)="cancel()"nzTheme="outline"></span></a>-->
                <!--              </div>-->
              </div>
            </div>
          </div>
        </div>
      </nz-card>

      <nz-card *ngIf="popupLoading">
        <p class="text-primary">Loading...</p>
      </nz-card>
    </section>
  </ng-container>

  <ng-container *nzModalFooter>
    <div class="flex justify-end sm:justify-end">
      <a
        nz-popconfirm
        nzPopconfirmTitle="Are you sure you want to cancel this record? you will loose all data."
        nzPopconfirmPlacement="bottom"
        (nzOnConfirm)="confirm()"
        (nzOnCancel)="onCancelConfirm()"
      >
        <button class="outline-button mr-3" nz-button nzType="default">Cancel</button>
      </a>
      <button
        nz-popconfirm
        nzPopconfirmTitle="Are you sure you want to save the data?"
        nzPopconfirmPlacement="bottom"
        nz-button nzType="primary"
        (nzOnConfirm)="onSubmit()" (nzOnCancel)="cancel()"
        [disabled]="paymentForm.invalid || paymentForm.get('items').value?.length === 0">{{type === 'add' ? 'Add Payment' : 'Update Payment'}}
      </button>
    </div>
  </ng-container>
</nz-modal>
